import React from 'react'

import Modal from 'react-bootstrap/lib/Modal.js'
import ReactNotify from 'react-notify'

import * as ReactNotifyCSS from '../../shared/ReactNotify/ReactNotify.css'
import * as css from './Fondos.css'
import classNames from 'classnames/bind'
import * as cssModal from './Modales.css'
let cx = classNames.bind(cssModal)

let PropTypes = React.PropTypes
var estados = [
    '-',
    ' Publicar',
    ' Publicado',
    ' Modificado',
    ' Modificado y Publicado'
]
var tipoHabitacion = [
    '-',
    ' Single',
    ' Doble',
    ' Cuádruple',
]
var habitacion = [
    '-',
    'single_con_bano',
    'doble_con_bano',
    'cuadruple_con_bano'
]
export class ModalTrigger extends React.Component{
    constructor(props){
        super(props)
        this.state = {visible: false}
        let self = this
        this.show = ()=>
            self.setState({visible: true})
        this.hide = ()=>{
            self.setState({visible: false})
        }
    }
    render(){
        return this.props.children(this.state.visible, this.show, this.hide)
    }
}
export class PublicarFondos extends React.Component{
    constructor(props){
        super(props)
        this.focusNComprobante = this.focusNComprobante.bind(this)
        this.state = {
            nComprobante: '',
            total: '',
            totalGeneral: 0,
            comprobantes: []
        }
        this.onInputChange = (key, evt)=>{
            this.setState({
                [key]: evt.target.value
             })
        }
        this.publicarFondos =()=>{
            this.refs.notificator.info("Fondos", "Publicando fondos...", 5*1000)
            this.context.publicarFondos(this.state.nComprobante, this.state.total)
                .then(resp=>{
                    this.props.hideModal()
                })
                .catch(err=>{
                    console.log(err)
                    this.refs.notificator.error("Fondos", "Ocurrió un error al publicar, reintente", 5*1000)
                })
        }
    }
    focusNComprobante(){
        this.inputNComprobante.focus()
    }
    componentWillMount(){
        this.context.comprobantesDeposito()
            .then(resp=>{
                this.setState({
                    comprobantes:resp.comprobantes,
                    totalGeneral: resp.total,
                    total: this.props.total - resp.total
                })
            })
            .catch(err=>{
                console.log(err)
            })
    }
    componentDidMount(){
        this.focusNComprobante()
    }
    render() {
        return (
            <Modal show={true} onHide={this.props.hideModal} dialogClassName={cx('modalPublicar')} className={cx('modal')}>
                <Modal.Header closeButton>
                    <Modal.Title>¿Desea públicar los fondos?</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="row">
                        <ReactNotify ref='notificator' className={ReactNotifyCSS}/>
                        <div className="col-md-12">
                            Los fondos serán informados al lider y quedarán disponibles para realizar la rendición.
                        </div>
                        <p/>
                        <div className="col-md-12">
                            {this.state.comprobantes?
                                <div className="form-group">
                                    <label>Comprobantes Anteriores </label>
                                    {
                                        this.state.comprobantes.map(comprobante=>{
                                            return <div className="col-md-12" key={comprobante.idComprobanteDeposito}>
                                                <div className="col-md-6">
                                                    <label>N° Comprobante: </label>{comprobante.numero_comprobante}
                                                </div>
                                                <div className="col-md-6">
                                                    <label>Total: </label> {comprobante.total.toLocaleString(navigator.language, { minimumFractionDigits: 0 })}
                                                </div>
                                            </div>
                                        })
                                    }
                                    <div className="col-md-6 pull-right">
                                        <label>Total girado semana: </label>{this.state.totalGeneral.toLocaleString(navigator.language, { minimumFractionDigits: 0 })}
                                    </div>
                                </div>
                                :
                                null
                            }
                        </div>
                        <div className="form-group">
                            <div className="col-md-12">
                                <label>Comprobante Nuevo </label>
                            </div>
                            <div className="col-md-6">
                                <label>Número Comprobante </label>
                                <input type="text" className="form-control"
                                    ref={(nComprobante) => { this.inputNComprobante = nComprobante }}
                                    value={this.state.nComprobante}
                                    onFocus={()=>{ this.inputNComprobante.select() }}
                                    onChange={this.onInputChange.bind(this, 'nComprobante')}
                                />
                            </div>
                            <div className="col-md-6">
                                <label>Total nuevo giro </label>
                                <input type="text" className="form-control"
                                    ref={(total) => { this.inputTotal = total }}
                                    value={this.state.total.toLocaleString(navigator.language, { minimumFractionDigits: 0 })}
                                    onFocus={()=>{ this.inputTotal.select() }}
                                    onChange={this.onInputChange.bind(this, 'total')}
                                />
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <div className="col-md-6">
                        <button className={this.props.estado_rendicion === 1 ||this.props.estado_rendicion === 3? "btn btn-md btn-primary pull-left" : "btn btn-md btn-success pull-left"}
                            onClick={()=>this.publicarFondos()}>
                            <span className="glyphicon glyphicon-ok"/> Publicar{estados[this.props.estado_rendicion]}
                        </button>
                    </div>   
                    <div className="col-md-6">
                        <button className="btn btn-md btn-cancel" onClick={this.props.hideModal}><span className="glyphicon glyphicon-remove"/> Cancelar</button>
                    </div>                        
                </Modal.Footer>
            </Modal>
        )
    }
}
PublicarFondos.contextTypes = {
    publicarFondos: PropTypes.func,
    comprobantesDeposito: PropTypes.func
}
export class ModalAlojamiento extends React.Component{
    constructor(props){
        super(props)
        this.state = {
            hospedajes: [],
            nombreComuna: '',
            hora_llegada: '',
            idHospedajeSeleccionado: 0,
            tipoHabitacion: 0
        }
        this.seleccionarHospedaje=(idHospedaje)=>{
            let detalleHospedaje = {
                'idDetalleHospedaje': 0,
                'idHospedaje': idHospedaje,
                'hora_llegada': this.state.hora_llegada, 
                'estado': 1, 
                'confirmacion_lider': 1,
                'tipo_habitacion': this.state.tipoHabitacion
            }

            this.context.guardarDetalleHospedaje(this.props.index, detalleHospedaje, this.props.servicio)
                .then(resp=>{
                    console.log(resp)
                    this.props.hideModal()
                })
                .catch(err=>{
                    console.log(err)
                })
        }
        this.selecTipoHabitacion=(tipoHabitacion)=>{
            this.setState({tipoHabitacion})
        }
    }
    componentWillMount(){
        if(this.props.idHospedaje === 0 || this.props.idHospedaje === null){
            this.context.buscarHospedajes(this.props.comuna)
                .then(resp=>{
                    this.setState({
                        nombreComuna: resp.nombreComuna,
                        hospedajes: resp.hospedajes
                    })
                })
                .catch(err=>{
                    console.log(err)
                })
        }else{
            this.context.buscarHospedajes(this.props.comuna)
                .then(resp=>{
                    this.setState({
                        nombreComuna: resp.nombreComuna,
                        hospedajes: resp.hospedajes,
                        idHospedajeSeleccionado: this.props.idHospedaje.idHospedaje
                    })
                })
                .catch(err=>{
                    console.log(err)
                })
        }
    }
    render() {
        let cantidadHospedajes = this.state.hospedajes.length
        return (
            <Modal show={true} onHide={this.props.hideModal} dialogClassName={this.props.idHospedaje === 0 || this.props.idHospedaje === null? cx('modalAlojamiento') : cx('modalShowAlojamiento')} className={cx('modal')}>
                <Modal.Header closeButton>
                    <Modal.Title>{this.props.idHospedaje === 0 || this.props.idHospedaje === null? "Hospedajes en "+this.state.nombreComuna : "Hospedaje Seleccionado"}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="row">
                        <div className="col-sm-12">
                            {cantidadHospedajes > 0 && (this.props.idHospedaje === 0 || this.props.idHospedaje === null)?
                                    <TablaHospedaje>
                                        {_.range(0, cantidadHospedajes).map(index=>{
                                            let hospedaje = this.state.hospedajes[index]
                                            return <tr key={index}>
                                                    {/* Index */}
                                                    <td className={cssModal.tdIndex}>{index+1}</td>
                                                    {/* Nombre */}
                                                    <td className={cssModal.tdNombre}>{hospedaje.nombre}</td>
                                                    {/* Prioridad */}
                                                    <td className={cssModal.tdPrioridad}>{hospedaje.prioridad}</td>
                                                    {/* Mail Principal */}
                                                    <td className={cssModal.tdMailPrincipal}>{hospedaje.mail_principal}</td>
                                                    {/* Mail Secundario */}
                                                    <td className={cssModal.tdMailSecundario}>{hospedaje.mail_secundario}</td>
                                                    {/* Telefono Fijo */}
                                                    <td className={cssModal.tdTelefonoFijo}>{hospedaje.telefono_fijo}</td>
                                                    {/* Celular */}
                                                    <td className={cssModal.tdCelular}>{hospedaje.celular}</td>
                                                    {/* Celular Wsp */}
                                                    <td className={cssModal.tdCelularWsp}>{hospedaje.celular_wsp}</td>
                                                    {/* Dirección */}
                                                    <td className={cssModal.tdDireccion}>{hospedaje.direccion}</td>
                                                    {/* Single Con Baño */}
                                                    <td className={cssModal.tdSingleConBano}>
                                                        <div className="col-md-6">
                                                            {hospedaje.single_con_bano.toLocaleString(navigator.language, { minimumFractionDigits: 0 })}
                                                        </div>
                                                        <div className="col-md-6">
                                                            <input type="checkbox"
                                                                checked={this.state.tipoHabitacion === 1? true : false}                            
                                                                onChange={()=>this.selecTipoHabitacion(1)}/>
                                                        </div>
                                                    </td>
                                                    {/* Doble Con Baño */}
                                                    <td className={cssModal.tdDobleConBano}>
                                                        <div className="col-md-6">
                                                            {hospedaje.doble_con_bano.toLocaleString(navigator.language, { minimumFractionDigits: 0 })}
                                                        </div>
                                                        <div className="col-md-6">
                                                            <input type="checkbox"
                                                                checked={this.state.tipoHabitacion === 2? true : false}                            
                                                                onChange={()=>this.selecTipoHabitacion(2)}/>
                                                        </div>
                                                    </td>
                                                    {/* Cuádruple Con Baño */}
                                                    <td className={cssModal.tdCuadrupleConBano}>
                                                        <div className="col-md-6">
                                                            {hospedaje.cuadruple_con_bano.toLocaleString(navigator.language, { minimumFractionDigits: 0 })}
                                                        </div>
                                                        <div className="col-md-6">
                                                            <input type="checkbox"
                                                                checked={this.state.tipoHabitacion === 3? true : false}                            
                                                                onChange={()=>this.selecTipoHabitacion(3)}/>
                                                        </div>
                                                    </td>
                                                    {/* Acciones */}
                                                    <td className={cssModal.tdAcciones}>
                                                        <button className={this.state.idHospedajeSeleccionado === hospedaje.idHospedaje? "btn btn-xs btn-primary glyphicon glyphicon-ok" : "btn btn-xs btn-success glyphicon glyphicon-ok"}
                                                            disabled={this.state.idHospedajeSeleccionado > 0 || this.state.tipoHabitacion === 0}
                                                            onClick={()=>this.seleccionarHospedaje(hospedaje.idHospedaje)}
                                                            title={this.state.idHospedajeSeleccionado}/>
                                                    </td>
                                                </tr>
                                        })}
                                    </TablaHospedaje>
                                :
                                    <div>
                                        {this.props.idHospedaje === 0 || this.props.idHospedaje === null?
                                            <label>No se encontraron hospedajes en la ciudad</label>
                                            :
                                            <div>
                                                <div className="form-group">
                                                    <div className="col-md-4">
                                                        <label>Nombre: </label>
                                                        <span> {this.props.idHospedaje.nombre}</span>
                                                    </div>
                                                    <div className="col-md-4">
                                                        <label>Ciudad: </label>
                                                        <span> {this.state.nombreComuna}</span>
                                                    </div>                                                    
                                                    <div className="col-md-4">
                                                        <label>Dirección: </label>
                                                        <span> {this.props.idHospedaje.direccion}</span>
                                                    </div>
                                                    <div className="col-md-4">
                                                        <label>Celular: </label>
                                                        <span> {this.props.idHospedaje.celular}</span>
                                                    </div>                                                    
                                                    <div className="col-md-4">
                                                        <label>Tipo Habitación: </label>
                                                        <span> {tipoHabitacion[this.props.idDetalleHospedaje.tipo_habitacion]}</span>
                                                    </div>
                                                    <div className="col-md-4">
                                                        <label>Valor: </label>
                                                        <span> {this.props.idHospedaje[habitacion[this.props.idDetalleHospedaje.tipo_habitacion]].toLocaleString(navigator.language, { minimumFractionDigits: 0 })}</span>
                                                    </div>
                                                    <div className="col-md-4">
                                                        <label>Estado Reserva: </label>
                                                        <span> {this.props.idDetalleHospedaje.estado === 1? "Enviada" : "Confirmada"}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                    </div>
                            }
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-md btn-cancel" onClick={this.props.hideModal}>Cancelar</button>
                </Modal.Footer>
            </Modal>
        )
    }
}
ModalAlojamiento.contextTypes = {
    buscarHospedajes: PropTypes.func,
    guardarDetalleHospedaje: PropTypes.func
}
let TablaHospedaje = ({children}) =>
        <table className={"table table-condensed table-striped "+css.tableFixed}>
            <colgroup>
                <col className={cssModal.colIndex}/>
                <col className={cssModal.colNombre}/>
                <col className={cssModal.colPrioridad}/>
                <col className={cssModal.colMailPrincipal}/>
                <col className={cssModal.colMailSecundario}/>
                <col className={cssModal.colTelefonoFijo}/>
                <col className={cssModal.colCelular}/>
                <col className={cssModal.colCelularWsp}/>
                <col className={cssModal.colDireccion}/>
                <col className={cssModal.colSingleConBano}/>
                <col className={cssModal.colDobleConBano}/>
                <col className={cssModal.colCuadrupleConBano}/>
                <col className={cssModal.colAcciones}/>
            </colgroup>
            <thead>
                <tr>
                    <th className={cssModal.thIndex}>#</th>
                    <th className={cssModal.thNombre}>Nombre</th>
                    <th className={cssModal.thPrioridad}>Prioridad</th>
                    <th className={cssModal.thMailPrincipal}>Mail Principal</th>
                    <th className={cssModal.thMailSecundario}>Mail Secundario</th>
                    <th className={cssModal.thTelefonoFijo}>Tel. Fijo</th>
                    <th className={cssModal.thCelular}>Celular</th>
                    <th className={cssModal.thCelularWsp}>Whatsapp</th>
                    <th className={cssModal.thDireccion}>Dirección</th>
                    <th className={cssModal.thSingleConBano}>Single</th>
                    <th className={cssModal.thDobleConBano}>Doble</th>
                    <th className={cssModal.thCuadrupleConBano}>Cuádruple</th>
                    <th className={cssModal.thAcciones}/>
                </tr>
            </thead>
            <tbody>
                {children}
            </tbody>
        </table>
export class ModalPasaje extends React.Component{
    constructor(props){
        super(props)
        this.state = {
            comprobante: '',
            hora_pasaje: '',
            bus: '',
            codigo_pasaje: '',
            se_imprime: false,
            error: []
        }
        this.onInputChange = (key, evt)=>{
            this.setState({
                [key]: evt.target.type === 'checkbox'? evt.target.checked : evt.target.value
            })
        }
        this.guardaPasaje=()=>{
                let actualizado = this.props.servicio
                actualizado.comprobante = this.state.comprobante
                this.context.subirComprobante(this.props.index, actualizado)
                    .then(resp=>{
                       let datosPasaje = {
                            'horario_pasaje': this.state.hora_pasaje,
                            'bus': this.state.bus,
                            'codigo_pasaje': this.state.codigo_pasaje, 
                            'se_imprime': this.state.se_imprime, 
                        }
                        this.setState({
                            error: []
                        })
                        this.context.guardaDatosPasaje(this.props.index, resp.idBoletoPasaje, datosPasaje)
                            .then(resp=>{
                                this.setState({
                                    error: []
                                })
                                this.props.hideModal()
                            })
                            .catch(err=>{
                                console.log(err)
                                this.setState({
                                    error: err.data
                                })
                            })
                    })
                    .catch(err=>{
                        console.log(err)
                        this.setState({
                            error: err.data
                        })
                    })
            }
    }
    onComprobanteChange(evt){
        this.setState({
            comprobante: evt.target.files[0]
        })
    }
    componentWillMount(){
        if(this.props.servicio.boletoPasaje){
            this.setState({
                comprobante: this.props.servicio.boletoPasaje.nombre,
                hora_pasaje: this.props.servicio.boletoPasaje.horario_pasaje,
                bus: this.props.servicio.boletoPasaje.bus,
                codigo_pasaje: this.props.servicio.boletoPasaje.codigo_pasaje,
                se_imprime: this.props.servicio.boletoPasaje.se_imprime
            })
        }
    }
    render() {
        return (
            <Modal show={true} onHide={this.props.hideModal} dialogClassName={cx('modalPasaje')} className={cx('modal')}>
                <Modal.Header closeButton>
                    <Modal.Title>Pasajes</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="row">
                        <div className="form-group">
                            <div className="col-md-12">
                                <div className="col-md-6">
                                    <label>Hora Pasaje </label>
                                    <input type="time" className="form-control"
                                        value={this.state.hora_pasaje}
                                        onChange={this.onInputChange.bind(this, 'hora_pasaje')}
                                        disabled={this.props.servicio.boletoPasaje}
                                    />
                                    {this.state.error.hora_pasaje && <span className={cx('form__error-message')}>{this.state.error.hora_pasaje}</span>}
                                </div>
                                <div className="col-md-6">
                                    <label>Bus </label>
                                    <input type="text" className="form-control"
                                        value={this.state.bus}
                                        onChange={this.onInputChange.bind(this, 'bus')}
                                        disabled={this.props.servicio.boletoPasaje}
                                    />
                                    {this.state.error.bus && <span className={cx('form__error-message')}>{this.state.error.bus}</span>}
                                </div>
                            </div>
                            <div className="col-md-12">
                                <div className="col-md-6">
                                    <label>Código Pasaje </label>
                                    <input type="text" className="form-control"
                                        value={this.state.codigo_pasaje}
                                        onChange={this.onInputChange.bind(this, 'codigo_pasaje')}
                                        disabled={this.props.servicio.boletoPasaje}
                                    />
                                    {this.state.error.codigo_pasaje && <span className={cx('form__error-message')}>{this.state.error.codigo_pasaje}</span>}
                                </div>
                                <div className="col-md-6">
                                    <label>¿Se Imprime? </label>
                                    <input type="checkbox" className="form-control"
                                        checked={this.state.se_imprime}
                                        onChange={this.onInputChange.bind(this, 'se_imprime')}
                                        disabled={this.props.servicio.boletoPasaje}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="col-md-12">
                            <div className="col-md-3">
                                <label>Comprobante</label>
                                <input id="subirComprobante" type="file"
                                        onChange={this.onComprobanteChange.bind(this)}
                                        disabled={!this.props.servicio.diaTrabajado || this.props.servicio.boletoPasaje} 
                                        title="Seleccionar Comprobante"/>
                                {this.state.error.comprobante && <span className={cx('form__error-message')}>{this.state.error.comprobante}</span>}
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <div className="col-md-12">
                        <div className="col-md-2 pull-left">
                            <button className="btn btn-d btn-primary" 
                                onClick={this.guardaPasaje} 
                                disabled={this.props.servicio.boletoPasaje}>Guardar</button>
                        </div>
                        <div className="col-md-10 pull-right">
                            <button className="btn btn-md btn-cancel" onClick={this.props.hideModal}>Cancelar</button>
                        </div>
                    </div>
                </Modal.Footer>
            </Modal>
        )
    }
}
ModalPasaje.contextTypes = {
    subirComprobante: PropTypes.func,
    guardarDetalleHospedaje: PropTypes.func,
    guardaDatosPasaje: PropTypes.func
}


// WEBPACK FOOTER //
// ./frontEnd/contabilidad/asignacion-fondos/Modales.jsx